import { Component, OnInit } from "@angular/core";
import { AppConfig } from 'src/app/app-config';
import { JsLoaderService } from "src/shared/services/js-loader.service";

@Component({
  selector: "app-covid19",
  templateUrl: "./covid19.component.html",
})
export class Covid19Component implements OnInit {
  constructor(private jsLoader: JsLoaderService, private config: AppConfig) { }
  userGuide = this.config.covidUserGuide;
  immunizationGuide = this.config.ImmuniationUserGuide;

  ngOnInit() {
    this.jsLoader.loadScripts();
  }
}
